import { IconVoucherBold } from "@/app/components/icon-tsx/IconVoucherBold"
import { LoadingBtnComponent } from "@/app/components/loading-btn"
import { AppContext } from "@/app/context"
import { ITopupSelectedData } from "@/app/interfaces/ITopup"
import { useTranslation } from "next-i18next"
import React, { FC, useContext, useEffect, useState } from "react"

interface VoucherComponentProps {
  setErrorCode: (errorCode: string) => void
  errorCode: string
  selectedData: ITopupSelectedData
  setSelectedData: (selectedData: ITopupSelectedData) => void
  checkVoucher: (value: string) => void
  loading: boolean
  applyVoucher: any
  total: number
  setApplyVoucher: (applyVoucher: any) => void
}

export const VoucherComponent: FC<VoucherComponentProps> = ({
  setErrorCode,
  errorCode,
  selectedData,
  setSelectedData,
  checkVoucher,
  loading,
  applyVoucher,
  total,
  setApplyVoucher
}) => {
  const { t } = useTranslation()
  const { themeApp } = useContext(AppContext)
  const [value, setValue] = useState("")

  useEffect(() => {
    if (selectedData?.voucher_code) {
      setValue(selectedData?.voucher_code || "")
      setErrorCode("")
    }
  }, [selectedData?.voucher_code])

  return (
    <div>
      <div className="my-[16px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"></div>
      {/* enter code voucher */}
      <div className="rounded-[8px] flex overflow-hidden h-[36px] mt-[24px]">
        <div className="flex-1 border border-r-0 dark:bg-white/10 border-black/10 rounded-tl-[8px] rounded-bl-[8px] py-[8px] px-[16px] flex gap-2">
          <input
            className="flex-1 h-full outline-0 bg-transparent border-0 text-[14px]"
            value={value}
            onChange={(e: any) => {
              setValue(e.target.value)
              setErrorCode("")
            }}
            placeholder={t("store.voucher_placeholder")}
          ></input>
          {value && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              onClick={() => {
                setValue("")
                setErrorCode("")
                setSelectedData({
                  ...selectedData,
                  voucher_code: ""
                })
                setApplyVoucher(null)
              }}
              className="cursor-pointer"
            >
              <circle
                cx="8"
                cy="8"
                r="7"
                fill={themeApp === "dark" ? "#FFFFFF1A" : "black"}
              />
              <path
                d="M11.3 5.64286L10.3573 4.7002L7.99995 7.05753L5.64262 4.7002L4.69995 5.64286L7.05728 8.0002L4.69995 10.3575L5.64262 11.3002L7.99995 8.94286L10.3573 11.3002L11.3 10.3575L8.94262 8.0002L11.3 5.64286Z"
                fill="white"
              />
            </svg>
          )}
        </div>
        <div
          className={`w-[80px] text-[14px] Nunito-500 items-center flex justify-center bg-button dark:bg-white/20 border rounded-tr-[8px] rounded-br-[8px] border-black/10 ${
            value.trim()
              ? "text-main-01 cursor-pointer"
              : "text-main-disable opacita-80"
          }`}
          onClick={() => checkVoucher(value.trim())}
        >
          {!loading ? t("store.apply") : <LoadingBtnComponent />}
        </div>
      </div>

      <p className="Nunito-400 text-[#EB5757] text-[14px]">{errorCode}</p>

      <div className="flex justify-between mt-[12px] md:px-[16px] gap-3">
        {applyVoucher?.voucher?.name ? (
          <div className="flex items-center gap-2 flex-1">
            <IconVoucherBold />
            <p className="text-[14px] text-neutral-06 dark:text-neutral-07 flex-1 line-clamp-1">
              {applyVoucher?.voucher?.name}
            </p>
          </div>
        ) : (
          <p className="text-[14px] text-neutral-06 dark:text-neutral-07">
            {t("store.voucher_title")}:
          </p>
        )}

        <p className="text-[16px] Nunito-600">
          -
          {applyVoucher?.pay_amount
            ? `đ ${(total - applyVoucher.pay_amount).toLocaleString()}`
            : " 0 đ"}
        </p>
      </div>
    </div>
  )
}
